import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getUrlQuerysection } from "../../../helpers";
import { pathConstants } from "../../../routes/pathContants";

const useAppGuard = () => {
  const [grantAccess, setGrantAcces] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!localStorage.getItem("refreshToken")) {
      localStorage.setItem(
        "nextRoute",
        location.pathname + getUrlQuerysection(),
      );
      return navigate(pathConstants.LOGIN);
    }

    setGrantAcces(true);
  }, []);

  return { grantAccess };
};

export default useAppGuard;
